import { Lock } from "lucide-react";
import useTranslation from "../../../client/hooks/useTranslation";
import { Button } from "../../../client/components/ui/button";
import { cardCls } from "../../ui/ui";

/**
 * Verrou bêta Edgy (plans hors Max) : mêmes textes que l'écran BETA_LOCKED du
 * tiroir Advanced, mais le bouton ouvre la vraie modale de plans du Lite.
 */
export function EdgyLockCard({ onUpgrade, note }: { onUpgrade: () => void; note?: string }) {
  const t = useTranslation().edgy.betaLock;
  return (
    <section className={`${cardCls} px-6 py-10 flex flex-col items-center gap-4 text-center`}>
      <span className="w-14 h-14 rounded-full grid place-items-center bg-primary/10 ring-1 ring-inset ring-primary/30">
        <Lock className="h-6 w-6 text-primary" />
      </span>
      <div className="flex flex-col items-center gap-2">
        <span className="rounded-full bg-primary/10 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-primary">{t.badge}</span>
        <h2 className="font-display text-lg font-bold">{t.title}</h2>
        <p className="max-w-md text-sm text-muted-foreground">{t.description}</p>
      </div>
      <Button onClick={onUpgrade}>{t.upgrade}</Button>
      {note && <p className="max-w-md text-xs text-muted-foreground/80">{note}</p>}
    </section>
  );
}
